export default __webpack_public_path__ + "static/media/background2.a275f8d0.png";